import TraitsListHeadTab from './TraitsListHeadTab'

export default TraitsListHeadTab
